import { filterUserEventsByQuery, sortUserEvents } from '@/util/sort';
import SearchField from '@/components/common/SearchField';
import { UserEventItem } from '@/components/userevents/UserEventsManager';
import { useApplication } from '@/hooks/useApplication';
import { UserEventSortType } from '@/types/eventhandler';
import { userEventSearchOptions } from '@/util/userevents';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

type UserEventsPickerDialogProps = {
  open: boolean;
  handleSave: (userEvent: UserEventItem) => void;
  onClose: () => void;
};

const UserEventsPickerDialog: FC<UserEventsPickerDialogProps> = (props) => {
  const { application } = useApplication();
  const [selectedItem, setSelectedItem] = useState<UserEventItem>();
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useLocalStorage<UserEventSortType>('userEventSort', 'event');
  const [invert, setInvert] = useState<boolean>(false);

  const handleClose = () => {
    setSelectedItem(undefined);
    props.onClose();
  };

  useEffect(() => setSearchQuery(''), [props.open]);

  return (
    <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth='sm'>
      <DialogTitle>
        Pick User Event
        {application.userevents && application.userevents.length > 4 && (
          <SearchField
            searchQuery={searchQuery}
            setSearchQuery={(query) => setSearchQuery(query)}
            sortBy={sortBy}
            invert={invert}
            onSort={(changeSortBy, reverse) => {
              changeSortBy && setSortBy(changeSortBy as UserEventSortType);
              reverse && setInvert(!invert);
            }}
            searchOptions={userEventSearchOptions}
            autoFocus={props.open}
          />
        )}
      </DialogTitle>
      {application.userevents && (
        <DialogContent>
          {filterUserEventsByQuery(sortUserEvents(application.userevents, sortBy, invert), searchQuery)?.map(
            (userEvent) => (
              <List key={userEvent.event} sx={{ width: '100%' }}>
                <ListItemButton
                  key={`userevent.${userEvent.event}`}
                  selected={userEvent.event === selectedItem?.event}
                  onClick={() => setSelectedItem(userEvent)}
                  onDoubleClick={() => props.handleSave(userEvent)}
                >
                  <ListItemText
                    primary={userEvent.event}
                    secondary={<code>{userEvent.label}</code>}
                    disableTypography
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  />
                </ListItemButton>
              </List>
            )
          )}
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Cancel
        </Button>
        <Button
          disabled={selectedItem === undefined}
          onClick={() => {
            selectedItem !== undefined && props.handleSave(selectedItem);
          }}
          color='primary'
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserEventsPickerDialog;
